module.exports = __webpack_public_path__ + "static/img/博士_2023_徐仁乐_renlexu@nwafu.edu.cn.3ba43eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/members/博士_2023_徐仁乐_renlexu@nwafu.edu.cn.jpg
// module id = ohUo
// module chunks = 6